import React from "react";
import { Link } from "react-router-dom";

const FooterTwo = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="footer-wrapper footer-layout2"
      style={{ backgroundImage: "url(assets/img/bg/footer-bg2-1.png)" }}
    >
      <div className="container">
        <div className="widget-area">
          <div className="row justify-content-between">
            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget widget-about">
                <div className="about-logo">
                  <Link to="/">
                    <img src="assets/img/logo.svg" alt="Grupo Rocvel Consultoria de RH" />
                  </Link>
                </div>
                <p className="footer-text mb-30">
                  Soluções estratégicas em recrutamento, hunting e fornecimento de mão de obra especializada em todo o território nacional.
                </p>
                <div className="social-btn style3">
                  <span className="social-title">Siga-nos</span>
                  <Link to="https://www.facebook.com/share/1DUYht6Ytb/?mibextid=wwXIfr">
                    <i className="fab fa-facebook-f" />
                  </Link>
                  <Link to="https://www.instagram.com/grupo.rocvel/">
                    <i className="fab fa-instagram" />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-3">
              <div className="widget footer-widget">
                <h3 className="widget_title">Contato</h3>
                <div className="widget-contact2">
                  <div className="widget-contact-grid">
                    <div className="icon">
                      <i className="fas fa-envelope" />
                    </div>
                    <div className="contact-grid-details">
                      <h6>
                        <a href="mailto:atendimento@gruporocvel.com.br" style={{ color: "inherit" }}>
                          atendimento@gruporocvel.com.br
                        </a>
                      </h6>
                    </div>
                  </div>
                  <div className="widget-contact-grid">
                    <div className="icon">
                      <i className="fas fa-map-marker-alt" />
                    </div>
                    <div className="contact-grid-details">
                      <h6>
                        Av. Paulista, 1636 Conj. 05
                        <br />
                        Av. Paulista, 2439 - 11º andar
                        <br />
                        São Paulo - SP
                      </h6>
                    </div>
                  </div>
                  <div className="widget-contact-grid">
                    <div className="icon">
                      <i className="fas fa-phone-alt" />
                    </div>
                    <div className="contact-grid-details">
                      <h6>
                        <a href="tel:+5511915259017" style={{ color: "inherit" }}>
                          (11) 91525-9017
                        </a>
                        <br />
                        <a href="tel:+5511913292398" style={{ color: "inherit" }}>
                          (11) 91329-2398
                        </a>
                      </h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-xl-auto">
              <div className="widget widget_nav_menu footer-widget">
                <h3 className="widget_title">Links Úteis</h3>
                <div className="menu-all-pages-container">
                  <ul className="menu">
                    <li>
                      <Link to="/">Início</Link>
                    </li>
                    <li>
                      <Link to="/sobre-nos">Sobre Nós</Link>
                    </li>
                    <li>
                      <Link to="/servicos">Nossos Serviços</Link>
                    </li>
                    <li>
                      <Link to="/faq">Perguntas Frequentes</Link>
                    </li>
                    <li>
                      <Link to="/contato">Fale Conosco</Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-wrap">
        <div className="container">
          <div className="row gy-3 justify-content-lg-between justify-content-center">
            <div className="col-auto align-self-center">
              <p className="copyright-text text-center">
                © <Link to="/">Grupo Rocvel</Link> {currentYear} | Todos os Direitos Reservados
              </p>
            </div>
            <div className="col-auto">
              <div className="footer-links">
                <p className="copyright-text text-center">
                  Desenvolvido com ❤️ pela{" "}
                  <a 
                    href="https://www.doi2versos.com.br" 
                    target="_blank" 
                    rel="noopener noreferrer"
                  >
                    Doi2versos
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterTwo;